var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { classes, st } from './Image.st.css';
import { WowImage } from '../WowImage/WowImage';
/** Image is a component to literally display an image - whether an absolute with full URL or a media platform item with relative URI */
export class Image extends React.Component {
    render() {
        const _a = this.props, { className } = _a, imageProps = __rest(_a, ["className"]);
        return React.createElement(WowImage, Object.assign({ className: st(classes.root, className) }, imageProps));
    }
}
//# sourceMappingURL=Image.js.map